import { usePixelStreamingContext } from '../contexts/PixelStreamingContext';

interface AvatarModalMessage {
  type: 'avatar_modal:open';
}

export default function useOpenAvatarModal() {
  const { emitUIInteraction } = usePixelStreamingContext();
  if (!emitUIInteraction) return () => {};
  return () => emitUIInteraction({ type: 'avatar_modal:open' } as AvatarModalMessage);
}
